import { createSubscribableMutator } from '@famly/vet_apollo-utils_create-subscribable-mutator';
import { UpdateLeaveRangeMutation } from './update-leave-range.mutation';
export const { useSubscribableMutation: useUpdateLeaveRange, useSubscribeMutationResult: useUpdateLeaveRangeResult } = createSubscribableMutator(UpdateLeaveRangeMutation);
